<div class="splash-text-container-outer">
	<div class="splash-text-container">
		<p class="main-message">{{ systemConfigService.config.name }}</p>
	</div>
</div>
